import { Card, Col, Row } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useCardStats, useMeetingsByAgenda, useMeetingTimePerMonth, useStatusBreakdownPerPeriod, useVisitsPerMonth } from '../hooks/useDashboard.ts';
import AppInit from './AppInit';
import StatusBreakDown from './StatusBreakDown.tsx';
import DashboardCardList from './charts/DashboardCardList.tsx';
import DashboardGraphs from './charts/DashboardGraphs.tsx';
import MeetingByAgenda from './charts/MeetingByAgenda.tsx';
import MeetingStatusAnalytics from './charts/MeetingStatusAnalytics.tsx';

const Dashboard = () => {
  const today = dayjs();
  const sixMonthsAgo = today.subtract(5, 'month');

  const defaultFilter = {
    rangeType: 'monthly',
    fromDate: sixMonthsAgo.startOf('day').format('YYYY-MM-DD'),
    toDate: today.endOf('day').format('YYYY-MM-DD'),
  };

  const [visitsFilter, setVisitsFilter] = useState(defaultFilter);
  const [hoursFilter, setHoursFilter] = useState(defaultFilter);
  const [statusFilter, setStatusFilter] = useState(defaultFilter);

  const { data: cardList } = useCardStats();

  const { data: visitsPerMonth } =useVisitsPerMonth(visitsFilter);

  const { data: meetingTimePerMonth } =useMeetingTimePerMonth(hoursFilter);


  const { data: meetingPerAgendaList } = useMeetingsByAgenda();
  const { data: statusWiseList } = useStatusBreakdownPerPeriod(statusFilter);

  console.log(statusWiseList, "jhsdghgh");



  const handleVisitsFilterChange = (filter: any) => {
    setVisitsFilter({
      rangeType: filter.period,
      fromDate: filter.fromDate,
      toDate: filter.toDate,
    });
  };

  const handleHoursFilterChange = (filter: any) => {
    setHoursFilter({
      rangeType: filter.period,
      fromDate: filter.fromDate,
      toDate: filter.toDate,
    });
  };

  const handleStatusFilterChange = (filter: any) => {
    setStatusFilter({
      rangeType: filter.period,
      fromDate: filter.fromDate,
      toDate: filter.toDate,
    });
  };



  return (
    <div>
      <AppInit />
      <DashboardCardList cardList={cardList?.data} />


      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-5">
        <DashboardGraphs
          meetingsPerMonth={visitsPerMonth?.data || []}
          onFilterChange={handleVisitsFilterChange}
          title="Visits Per Month"
        />

        <DashboardGraphs
          meetingsPerMonth={meetingTimePerMonth?.data || []}
          onFilterChange={handleHoursFilterChange}
          title="Visits Time Per Month (hrs)"
        />

      </div>



      <Row gutter={[16, 16]} className=" mt-6!">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Card title="Visits Status Analytics" className="h-full">
            <MeetingStatusAnalytics meetingStatusAnalytics={cardList?.data || []} />
          </Card>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Card title="Visits by Agenda" className="h-full">
            <MeetingByAgenda meetingsByAgenda={meetingPerAgendaList?.data} />
          </Card>
        </Col>
      </Row>

      <StatusBreakDown
        statusBreakdownPerMonth={statusWiseList?.data || []}
        onFilterChange={handleStatusFilterChange}
      />

    </div>
  );
};

export default Dashboard;
